import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ClipboardService } from '@core/services/clipboard.service';
import { ContextMenuService } from '@core/services/context-menu.service';
import { SessionService } from '@core/services/session.service';
import { ChatEmotePipe } from '@features/chat/pipes/chat-emote.pipe';
import { SupportTicketMessage } from '../interfaces/ticket.interface';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { ADMIN_LEVELS as levels } from '@core/constants/admin-levels.constants';

interface ExtraBadges {
  title: string;
}
@Component({
  selector: 'app-chat-support-message',
  imports: [ChatEmotePipe, PlayerRowComponent],
  templateUrl: './chat-support-message.component.html',
  styleUrl: './chat-support-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[class.outlined]': 'message().__outlined',
  },
})
export class ChatSupportMessageComponent {
  public sessionService = inject(SessionService);
  public contextMenuService = inject(ContextMenuService);
  public clipboardService = inject(ClipboardService);

  readonly ADMIN_LEVELS = levels;
  message = input.required<SupportTicketMessage>();

  messageFeatureBadges = input<ExtraBadges[]>([]);
}
